 /**
 * Subscription Popup Module
 */
let subscription = () => {

  let module = {},
      body,

    init = () => {

      /**
       * Subscription Panel
       */
      const subsPanel = $('.subscription-section');
      const subsPanelInitial = $('.subscription-initial');
      const subsPanelPrimary = $('.subscription-primary');
      const subsPanelSecondary = $('.subscription-secondary');
      const subsPanelSuccess = $('.subscription-success');
      const bgWrapper = $('.background-wrapper');
      var body = $('html,body');

      // New yo
      const subModalMobileStep1 = $('#subscriptionModalMobileStep1');
      const subModalMobileStep2 = $('#subscriptionModalMobileStep2');
      const subModalMobile = $('#subscribeModal');
      const subModal = $('#subscribeModalDesktop');
      const subButton = $('.subscription__initial button');
      const subButtonConfirm = $('#subscribeModalDesktop button');

      const subLabel = $('.subscription__initial')
      const subLabelConfirm = $('.subscription__confirmation')
      const subLabelMobile = $('.subscription__initial-mobile')
      const subLabelConfirmMobile = $('.subscription__confirmation-mobile')

      const subButtonMobile = $('#subscribeButtonMobile');
      const subButtonConfirmMobile = $('#subscriptionButtonConfirmMobile');

      const emailRegex = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");

      // Mobile Email validation
      subButtonMobile.on('click', function(e) {

        if (validate_initial('.subscription__initial--mobile')) {
          $('.form__invalid').hide();

          ga('send', 'event', 'subscription-mobile-open', 'click', 'webpage');

          subModalMobileStep1.slideToggle();
          subModalMobileStep2.slideToggle();
        }

      });

      // Desktop email validation
      subButton.on('click', function(e) {
        e.preventDefault();

        if (validate_initial('.subscription__initial--desktop')) {
          $('.form__invalid').hide();

          ga('send', 'event', 'subscription-desktop-open', 'click', 'webpage');
          subModal.modal('show');
        }
      });

      // Email + terms
      function validate_initial(selector) {
        let valid = true;

        if (! emailRegex.test($(selector + ' .form__email').val())) {
          $(selector + ' #error-email').slideDown();
          valid = false;
        } else {
          $(selector + ' #error-email').slideUp();
        }

        if (! $(selector + ' .form__check').is(':checked')) {
          $(selector + ' #error-terms').slideDown();
          valid = false;
        } else {
          $(selector + ' #error-terms').slideUp();
        }

        return valid;
      }

      // we need at least 1 element selected
      function validate_categories(selector) {
        let valid = false;

        // jQuery .each breaks after false is returned.
        // If a checkbox is checked we return false
        $(selector).each(function () {
          if ($(this).is(':checked')) {
            valid = true;
            return false;
          }
        });

        if (! valid) {
          $(selector + ' .form__invalid').slideDown();
        } else {
          $(selector + ' .form__invalid').slideUp();
        }

        return valid;
      }

      subButtonConfirmMobile.on('click', function(e) {
        e.preventDefault();

        if (! validate_categories('.form__check-mobile')) {
          return;
        }

        ga('send', 'event', 'subscription-mobile-confirmation', 'click', 'webpage');

        subLabelMobile.hide();
        subLabelConfirmMobile.show();
        subLabel.hide().removeClass('d-lg-block');
        subLabelConfirm.show().removeClass('d-lg-none').addClass('d-lg-block');

        subModalMobile.modal('hide');

      })

      subButtonConfirm.on('click', function(e) {
        e.preventDefault();

        if (! validate_categories('.form__check-desktop')) {
          return;
        }

        subLabelMobile.hide();
        subLabelConfirmMobile.show();
        subLabel.hide().removeClass('d-lg-block');
        subLabelConfirm.show().removeClass('d-lg-none').addClass('d-lg-block');

        ga('send', 'event', 'subscription-desktop-confirmation', 'click', 'webpage');

        subModal.modal('hide');

        $([document.documentElement, document.body]).animate({
          scrollTop: $('.subscription').offset().top
        }, 1000);
      });

      // End of new yo

      /**
       * Checkbox
       */
      const subsCardBtn = subsPanel.find('.btn-product-card');
      subsCardBtn.on('click', function (e) {
        e.preventDefault();
        let target = $(this);
        let checkBox = target.find('.product-card-checkbox');
        target.toggleClass('active');
        checkBox.attr('checked', !checkBox.attr('checked'));
      });

      const agreementLabel = $('.agreement-label');
      agreementLabel.on('click', function (e) {
        e.preventDefault();
        let target = $(this);
        let checkBox = target.find('.agreement-checkbox');
        target.toggleClass('active');
        checkBox.attr('checked', !checkBox.attr('checked'));
      });

      /**
       * Initial
       */
      const btnSubscriptionInitial = $('.btn-subscription-initial');
      btnSubscriptionInitial.on('click', function (e) {
        e.preventDefault();

        // Hide another subscription forms
        $('.subscription-section').addClass('invisible');
        let target = $(this).closest('.subscription-section');
        target.removeClass('invisible');

        body.addClass('overflow-hidden');
        subsPanelInitial.hide();
        bgWrapper.show();
        subsPanelPrimary.fadeIn();
        $('.main-slider-subscription').css('z-index', 1000);
      });

      /**
       * Show Secondary Panel
       */
      const subscriptionSubmit = $('.subscription-submit');
      subscriptionSubmit.on('click', function (e) {
        e.preventDefault();
        subsPanelPrimary.hide();
        subsPanelSecondary.fadeIn();
      });

      /**
       * Show Success Panel
       */
      const btnSubsSelectProduct = $('.btnSubsSelectProduct');
      btnSubsSelectProduct.on('click', function (e) {
        e.preventDefault();
        subsPanelInitial.hide();
        subsPanelSuccess.show();

        finalisation();
      });

      /**
       * Hide Modal
       */
      const btnModalHide = $('.btn-modal-hide');
      btnModalHide.on('click', function (e) {
        e.preventDefault();
        subsPanelPrimary.hide();
        subsPanelInitial.show();

        finalisation();
      });

      /**
       * Shared finalisation actions
       */
      function finalisation() {
        body.removeClass('overflow-hidden');
        subsPanelSecondary.hide();
        bgWrapper.hide();
        $('.main-slider-subscription').attr('style', '');

        // Show another subscription forms
        $('.subscription-section').removeClass('invisible');
      }

      /**
       * Desktop: Back to Initial form
       */
      const btnModalReset = $('.btn-modal-reset');
      btnModalReset.on('click', function(e) {
        e.preventDefault();
        subsPanelPrimary.show();
        finalisation();
      });

    };

  module.init = init;

  return module;
};

export default subscription();